export default {
  PageName: 'POP信息',
  SearchPlaceholder: '搜索主机名/名称',
  hostname: '主机名',
  type: '类型',
  machineStatus: '机器状态',
  runningStatus: '	运行状态',
  location: '位置',
  nets: '出接口',
  PublicIP: '公网IP',
  name: '名称',
  area: '区域',
  address: '地址',
  serviceProvider: '服务商',
}